import React from 'react';
import { Box, Typography } from '@mui/material';

const InfoItem = ({ icon, label, value }) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Box sx={{ color: 'primary.main' }}>{icon}</Box>
      <Box>
        <Typography variant="body2" sx={{ color: 'text.secondary', lineHeight: 1 }}>
          {label}
        </Typography>
        <Typography variant="body1" sx={{ fontWeight: 500 }}>
          {value || '-'}
        </Typography>
      </Box>
    </Box>
  );
};

export default InfoItem;